<template>
  <nav class="ms-auto" role="navigation">
    <ul class="navbar-nav" aria-label="upper navigation bar">
      <!-- search bar -->
      <li v-if="!administrator" class="nav-item"><button class="commBtn" @click="callPatient"><font-awesome-icon
            icon="phone" class="icon" /></button></li>
      <li v-if="!administrator" class="nav-item"><button class="commBtn" @click="showText"><font-awesome-icon
            icon="comment" class="icon" /></button></li>
      <li aria-label="search">
        <form class="form-inline">
          <input class="form-control mr-sm-2 form-control-sm" type="search" placeholder="Search" aria-label="Search">
          <button class="icon--search" type="submit"><font-awesome-icon icon="search" class="icon" /></button>
        </form>
      </li>
      <li v-if="!administrator" class="nav-item"><span @click="getDirectives()" class="nav-link" data-bs-toggle="collapse"
          data-bs-target=".navbar-collapse.show">Directives</span></li>
      <li v-if="!administrator" class="nav-item"><span @click="getAllergies()" class="nav-link" data-bs-toggle="collapse"
          data-bs-target=".navbar-collapse.show">Allergies</span></li>

      <li class="nav-item dob"><router-link class="nav-link" to="#" data-bs-toggle="collapse"
          data-bs-target=".navbar-collapse.show" style="pointer-events: none">{{ user.dob }}</router-link></li>

      <li class="nav-item dropdown-li">
        <a class="nav-link name" :class="{ 'router-link-active': isSubMenuActive('user') }">{{ user.firstName }} {{
          user.lastName }} <font-awesome-icon icon="caret-down" /></a>
        <ul class="dropdown-li-ul" aria-label="dropdown">
          <li class="dropdown-li-ul-li"><router-link to="/user/profile" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Profile</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/user/contact" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Contact</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/user/devices" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Devices</router-link></li>
              <li class="dropdown-li-ul-li"><router-link to="/myAccount" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">My Account</router-link></li>
          <li class="dropdown-li-ul-li"><a role="button" @click="handleLogout">Log Out</a></li>
        </ul>
      </li>
    </ul>

    <div id="send-text-modal" class="send-text-modal" :style="{ 'display': 'none' }">
      <div class="inner-text-modal">
        <div class="form-group2">
          <label>Enter text body</label>
          <input type="text" required v-model="txtMsg" class="form-control2" />
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary" @click="sendText">Send</button>
          <button type="button" class="btn btn-secondary" @click="closeText">Cancel</button>
        </div>
      </div>
    </div>

  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from 'axios'
import $ from "jquery";
import { LogoutRequest } from '@/store/modules/fsm/messages';
import router from '@/router';
import { post } from '@/store/modules/fsm/index';
import { getAdministrator } from "@/data/getters";
import { Collapse } from 'bootstrap';
export default {
  name: "NavigationBarTop",
  data() {
    return {
      txtMsg: "Please visit the PACMNY application."
      // user: this.$store.getters['login/getUser'],
      // data: this.$store.getters['login/getAllData']
    }
  },
  computed: {
    ...mapGetters('login', {
      user: 'getUser',
      allData: "getAllData",
    }),
    administrator: function () {
      return getAdministrator(this.allData);
    },
    manager: function () {
      return this.allData.manager
    }
  },
  methods: {
    ...mapActions('login', [
      'logout'
    ]),
    handleLogout() {
      post({ message: LogoutRequest });
    },
    isSubMenuActive(parentPath) {
      return this.$route.path.indexOf(parentPath) === 1;
    },
    getAllergies() {
      this.$router.push({ name: 'AllergyNavigation' })
    },
    getDirectives() {
      this.$router.push({ name: 'DirectivesNavigation' })
    },
    closeNavbar(){
      let navbar = document.querySelector('.navbar-collapse.show');
            if (navbar) {
                new Collapse(navbar, {
                    toggle: false,
                }).hide();
            }
    },
    async callPatient() {
      if (!this.manager.phone1 && !this.manager.phone2) {
        alert("You have no phone number associated with your account. Please visit your profile page and set one.")
      }
      else if (!this.user.phone1 && !this.user.phone2) {
        alert("This patient has no phone number associated with their account.")
      }
      else {
        let content = {
          "Twilio": {
            "API_Meth": "SendPhoneCall",
            "from": this.manager.phone1 ? this.manager.phone1 : this.manager.phone2,
            "callnumber": this.user.phone1 ? this.user.phone1 : this.user.phone2
          }
        }
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);
            if (res.data.status != "") {
              alert("Connecting call...")
            }
            else {
              alert("Error connecting call.")
            }
          });
      }
    },
    async sendText() {
      if (!this.user.phone1 && !this.user.phone2) {
        alert("This patient has no phone number associated with their account.")
        return
      }
      let content = {
        "Twilio": {
          "API_Meth": "SendText",
          "smsnumber": this.user.phone1 ? this.user.phone1 : this.user.phone2,
          "smsmessage": this.txtMsg
        }
      }
      console.log(content)
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status != "") {
            alert("Text sent")
            this.closeText()
          }
          else {
            alert("Error sending text")
          }
        });
    },
    showText() {
      $("#send-text-modal").css("display", "flex")
    },
    closeText() {
      this.txtMsg = "Please visit the PACMNY application."
      $("#send-text-modal").css("display", "none")
    }
  }
}
</script>

<style scoped lang="scss">
$color-hover: darken(#ffffff, 10%);

@import "../../../stylesheets/modules/dropdown";

.commBtn {
  background-color: transparent;
  border: none;
}

.navbar-nav {
  font-size: 0.95rem;

  .nav-link {
    color: #fff;
    border-bottom: 1px solid transparent;
    cursor: pointer;
    display: inline-block;

    &:hover {
      color: $color-hover;
      border-bottom: 1px solid white;
    }
  }
}

.icon {
  color: #fff;
}

.icon--search {
  background-color: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    color: $color-hover;
    background-color: transparent;
  }
}

.router-link-active {
  border-bottom: 1px solid white !important;
}

.send-text-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.inner-text-modal {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-group2 label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 14px;
}

.form-control2 {
  display: block;
  width: 100%;
  height: 40px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: none;
}

.btn-group {
  display: flex;
  justify-content: flex-end;
}

.btn-primary,
.btn-secondary {
  height: 40px;
  padding: 0 20px;
}
</style>